import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Home/home.vue'

const routerPush = VueRouter.prototype.push;

VueRouter.prototype.push = function (location) {
  return routerPush.call(this, location).catch(err => { })
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import('../views/contactUs/contactUs.vue')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('../views/aboutUs/aboutUs.vue')
  },
  {
    path: '/alList',
    name: 'alList',
    component: () => import('../views/al/alList.vue')
  },
  {
    path: '/alTestInfo',
    name: 'alTestInfo',
    component: () => import('../views/al/alTestInfo.vue')
  },
  {
    path: '/alDetails',
    name: 'alDetails',
    component: () => import('../views/al/alDetails.vue')
  },
  {
    path: '/copDetail',
    name: 'copDetail',
    component: () => import('../views/cpCenter/copDetail/copDetail.vue')
  },
  {
    path: '/ecPlatform',
    name: 'ecPlatform',
    component: () => import('../views/cpCenter/ecPlatform/ecPlatform.vue')
  },
  {
    path: '/dzDetail',
    name: 'dzDetail',
    component: () => import('../views/cpCenter/dzDetail/dzDetail.vue')
  },
]



const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  // console.log(to)
  // console.log(from)
  // console.log(next)
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
  next()
})

export default router
